import { Text } from '@chakra-ui/react'

export function Title({ children }) {
  return (
    <Text
      fontSize="xl"
      fontWeight="bold"
      textAlign="center"
      as="h1"
      textTransform="uppercase"
      paddingBlock={4}
      width="100%"
      bg="#F1F1F1"
      color="#1A8AB6"
    >
      {children}
    </Text>
  )
}
